import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { InstitutionGroup } from './InstitutionGroup';
import { GROUPS_I_AM_ADMIN_OF } from './SecurityRules';

export interface InstitutionGroupTimeLabelRow {
  id: number;
  institution_group_id: number;
  title: string;
  start_date: string;
  created_at: string;
}

export const InstitutionGroupTimeLabel: Entity<InstitutionGroupTimeLabelRow> = {
  id: 'InstitutionGroupTimeLabel',
  title: 'Rotation',
  service: 'main',
  rowLabel: (row: InstitutionGroupTimeLabelRow) => row.title,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.institution_group_time_label',
  },
  security: [
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: `institution_group_id IN ${GROUPS_I_AM_ADMIN_OF}`,
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['start_date', 'ASC']],
  defaultFilters: [{ fieldId: 'title', operator: 'sw', value: '' }],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    institution_group_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Institution Group',
      listColumn: true,
      refEntity: InstitutionGroup,
    },
    title: {
      seq: 15,
      type: FieldType.Text,
      label: 'Title',
      mandatory: true,
      listColumn: true,
      maxLength: 80,
    },
    start_date: {
      seq: 20,
      label: 'Start Date',
      type: FieldType.Date,
      mandatory: true,
      listColumn: true,
    },
    created_at: {
      seq: 20,
      label: 'Created At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
